import React from "react";
import { translate } from "../../../utils/useful";

class Profitloss extends React.Component {
    render() {
        return (
            <div className="flexcc w-100 px-5">
                <div className="w-100 mb-4" style={{ maxWidth: '600px' }}>
                    <div className="flexcb mt-3">
                        <div>

                            <p style={{ fontSize: 15 }}>{translate('test')}</p>
                            <p>{translate('Profit and Loss')}</p>
                        </div>
                        <div>
                            <div className="d-flex align-items-center">
                                <p style={{ fontSize: 12 }}>{translate('Basis:')}</p>&nbsp;
                                <p style={{ fontSize: 12 }}>{translate('Accrual')}</p>
                            </div>
                            <div className="d-flex align-items-center">
                                <p style={{ fontSize: 12 }}>{translate('From')}</p>&nbsp;
                                <p style={{ fontSize: 12 }}>2023/01/01</p>&nbsp;
                                <p style={{ fontSize: 12 }}>{translate('Up to')}</p>&nbsp;
                                <p style={{ fontSize: 12 }}>2023/01/31</p>&nbsp;
                            </div>
                        </div>
                    </div>
                    <div className="mt-3">
                        <div style={{ display: 'flex', justifyContent: 'flex-end', }}>
                            <p style={{ color: '#408dfb', fontSize: 13 }}>{translate('+ Add Temporary Note')}</p>
                        </div>
                    </div>
                    <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                    <div className="flexcb my-2">
                        <div>
                            <p style={{ fontSize: 14 }}>{translate('Account')}</p>
                        </div>
                        <div>
                            <p style={{ fontSize: 14 }}>{translate('Total')}</p>
                        </div>
                    </div>
                    <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />

                    <div className="">
                        <div >
                            <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Operating Income')}</p>
                        </div>
                        <div className="flexcb mt-2">
                            <div>
                                <p style={{ fontSize: 13 }}>{translate('Total for Operating Income')}</p>
                            </div>
                            <div>
                                <p style={{ fontSize: 13 }}>0.0</p>
                            </div>

                        </div>

                    </div>
                    <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />

                    <div className="">
                        <div >
                            <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Cost of Goods Sold')}</p>
                        </div>
                        <div className="flexcb mt-2">
                            <div>
                                <p style={{ fontSize: 13 }}>{translate('Total for Cost of Goods Sold')}</p>
                            </div>
                            <div>
                                <p style={{ fontSize: 13 }}>0.0</p>
                            </div>

                        </div>

                    </div>
                    <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                    <div className="flexcb">
                        <div><p style={{ fontSize: 15, fontWeight: 'bold', color: '#408dfb' }}>{translate('Gross Profit')}</p></div>
                        <div><p style={{ fontSize: 15, color: '#408dfb' }}>0.0</p></div>
                    </div>
                    <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                    <div className="">
                        <div>
                            <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Operating Expense')}</p>
                        </div>
                        <div className="flexcb mt-2">
                            <div>
                                <p style={{ fontSize: 13 }}>{translate('Total for Operating Expense')}</p>
                            </div>
                            <div>
                                <p style={{ fontSize: 13 }}>0.0</p>
                            </div>

                        </div>

                    </div>
                    <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                    <div className="flexcb">
                        <div><p style={{ fontSize: 15, fontWeight: 'bold', color: '#408dfb' }}>{translate('Operating Profit')}</p></div>
                        <div><p style={{ fontSize: 15, color: '#408dfb' }}>0.0</p></div>
                    </div>
                    <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                    <div className="">
                        <div>
                            <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Non Operating Income')}</p>
                        </div>
                        <div className="flexcb mt-2">
                            <div>
                                <p style={{ fontSize: 13 }}>{translate('Total for Non Operating Income')}</p>
                            </div>
                            <div>
                                <p style={{ fontSize: 13 }}>0.0</p>
                            </div>

                        </div>

                    </div>
                    <div className="my-3" style={{ borderBottom: '1px solid #dadada' }} />
                    <div className="">
                        <div>
                            <p style={{ fontSize: 13, fontWeight: 'bold' }}>{translate('Non Operating Expense')}</p>
                        </div>
                        <div className="flexcb">
                            <div>
                                <p style={{ fontSize: 13 }}>{translate('Total for Non Operating Expense')}</p>
                            </div>
                            <div>
                                <p style={{ fontSize: 13 }}>0.0</p>
                            </div>

                        </div>

                    </div>
                    <div className="my-3 " style={{ borderBottom: '1px solid #dadada' }} />

                </div>
            </div>
        )
    }
}


export default Profitloss;